"use client";

import { useEffect } from "react";

export default function WistiaEmbed({ url }: { url: string }) {
  const embedId = url?.split("/").pop()?.split("?")[0]; // extract ID from URL

  useEffect(() => {
    if (typeof window !== "undefined") {
      const script = document.createElement("script");
      script.src = "https://fast.wistia.com/assets/external/E-v1.js";
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  return (
    <div className="w-full aspect-video">
      <div className={`wistia_embed wistia_async_${embedId} w-full h-full`} />
    </div>
  );
}
